import React from 'react';
import Breadcrumb from '../Breadcrumb';
import QueryError from '../QueryError';

// Page chrome for the resource wizard pages: breadcrumb, loading / error /
// not-found states and a dismissible banner for failed mutations.
export default function WizardPage({
  breadcrumb = [],
  loading,
  error,
  resource,
  notFoundLabel,
  task,
  children
}) {
  if (loading) return <div className="page-content">Loading...</div>;

  if (error) {
    return (
      <div className="page-content">
        <QueryError error={error} onRetry={() => window.location.reload()} />
      </div>
    );
  }

  if (!resource) return <div className="page-content">{notFoundLabel}</div>;

  return (
    <div className="page-content">
      <Breadcrumb items={breadcrumb} />
      {task?.error && (
        <div className="alert alert-danger alert-dismissible">
          {task.error}
          <button type="button" className="btn-close" onClick={task.clearError} />
        </div>
      )}
      {children}
    </div>
  );
}
